import { motion } from 'framer-motion'
import { FiSearch } from 'react-icons/fi'

type ThreadSearchProps = {
  value: string
  onChange: (value: string) => void
}

export function ThreadSearch({ value, onChange }: ThreadSearchProps) {
  return (
    <div className="border-b border-gray-200/50 p-3">
      <motion.div className="relative" whileFocus={{ scale: 1.02 }} transition={{ duration: 0.2 }}>
        <FiSearch className="text-ui-secondary absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 transition-colors" />
        <input
          type="text"
          placeholder="Search chats..."
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="text-ui-text w-full rounded-2xl border border-gray-200 bg-white py-2 pl-9 pr-3 text-sm outline-none transition-all focus:border-gray-400 focus:shadow-sm"
        />
      </motion.div>
    </div>
  )
}
